import InstitutionsStudentslist from "../../components/Students/Institutionstudentslist"

const InstitutionsStudents = () => {
  return (
    <div>
        <InstitutionsStudentslist />
    </div>
  )
}

export default InstitutionsStudents